var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeVitrine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 278,
    viewBox: "0 0 330 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.962 45.9513V62.9477C149.105 64.5095 145.9 65.3266 142.644 65.3235C137.452 65.3235 132.473 63.2605 128.802 59.5883C125.13 55.9162 123.068 50.9356 123.068 45.7424C123.063 41.896 124.198 38.1346 126.331 34.9336H140.947C143.869 34.9336 146.67 36.0944 148.736 38.1606C150.802 40.2268 151.962 43.0292 151.962 45.9513Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.948 34.9336H54.578C48.4947 34.9336 43.5632 39.8664 43.5632 45.9513V132.343C43.5632 138.428 48.4947 143.361 54.578 143.361H140.948C147.031 143.361 151.962 138.428 151.962 132.343V45.9513C151.962 39.8664 147.031 34.9336 140.948 34.9336Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4409 51.6406H71.2567",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4409 57.4629H81.358",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.073 34.9336H186.704C180.62 34.9336 175.689 39.8664 175.689 45.9513V132.343C175.689 138.428 180.62 143.361 186.704 143.361H273.073C279.156 143.361 284.088 138.428 284.088 132.343V45.9513C284.088 39.8664 279.156 34.9336 273.073 34.9336Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.566 51.6406H203.356",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.566 57.4629H213.483",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.948 168.266H54.578C48.4947 168.266 43.5632 173.198 43.5632 179.283V265.675C43.5632 271.76 48.4947 276.693 54.578 276.693H140.948C147.031 276.693 151.962 271.76 151.962 265.675V179.283C151.962 173.198 147.031 168.266 140.948 168.266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.085 259.986H124.295",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.085 254.162H114.167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.073 168.266H186.704C180.62 168.266 175.689 173.198 175.689 179.283V265.675C175.689 271.76 180.62 276.693 186.704 276.693H273.073C279.156 276.693 284.088 271.76 284.088 265.675V179.283C284.088 173.198 279.156 168.266 273.073 168.266Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.184 259.986H256.394",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.184 254.162H246.293",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4625 145.551C81.4625 145.551 86.3435 131.688 90.5458 120.044C94.7481 108.399 93.1559 102.133 85.8997 103.752C78.6435 105.371 58.4411 162.391 58.4411 162.391C57.4619 161.675 56.3298 161.196 55.134 160.992C53.9382 160.788 52.7114 160.865 51.5503 161.216",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.567 169.549C106.833 179.992 93.8087 193.046 87.7532 195.37C81.6976 197.693 79.3224 212.575 75.6421 213.645C73.815 214.115 69.2995 213.045 64.0009 210.747C57.8723 208.171 52.2173 204.589 47.2699 200.147C45.4167 198.764 52.699 185.422 52.699 185.422C52.699 185.422 41.6581 170.697 41.9974 163.7C42.415 155.267 45.7821 150.803 52.177 148.766C55.9257 147.69 59.8142 147.179 63.7138 147.252L64.7578 146.495L86.7874 130.647C94.2524 126.862 101.248 131.744 100.543 138.271L100.856 138.114C107.695 134.799 113.515 143.728 110.54 150.124H110.696C115.969 153.205 120.223 159.236 113.567 169.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0549 141.792C99.2324 140.938 99.1933 140.054 98.9413 139.219C98.6892 138.384 98.2322 137.626 97.6119 137.013C96.9916 136.401 96.2278 135.953 95.3902 135.711C94.5526 135.47 93.6678 135.442 92.8167 135.63C89.5018 136.701 85.5866 143.776 84.0988 147.013C82.6111 150.251 80.0009 147.797 81.7758 144.69L86.7873 130.565C94.2523 126.78 101.247 131.662 100.543 138.189L100.856 138.032L99.0549 141.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7573 146.414C64.4702 150.435 58.8323 161.296 58.8323 161.296L57.214 162.392L53.2466 161.009C50.6365 160.669 49.8274 157.327 52.7768 155.63C54.5778 154.586 54.1863 150.931 52.1765 148.685C55.9252 147.609 59.8137 147.098 63.7133 147.171L64.7573 146.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.567 169.546C106.833 179.989 93.8085 193.043 87.753 195.367C81.6975 197.691 79.3223 212.572 75.642 213.643C73.8149 214.113 69.2993 213.042 64.0007 210.745C73.6322 206.933 76.2945 195.08 76.2945 195.08C87.1784 189.204 96.9064 181.402 105.006 172.053C116.778 157.693 108.425 154.168 108.425 154.168L110.748 150.174C115.969 153.202 120.223 159.233 113.567 169.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.542 138.217C99.3475 142.01 97.4627 145.551 94.9829 148.66L100.542 138.217Z",
    fill: "#0049FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.539 150.07C110.539 150.07 110.226 152.681 104.954 158.216L110.539 150.07Z",
    fill: "#0049FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5605 196.932C77.9346 196.082 70.5859 193.579 64.0269 189.596L85.5605 196.932Z",
    fill: "#0049FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4625 145.551C81.4625 145.551 86.3435 131.688 90.5458 120.044C94.7481 108.399 93.1559 102.133 85.8997 103.752C78.6435 105.371 58.4411 162.391 58.4411 162.391C57.4619 161.675 56.3298 161.196 55.134 160.992C53.9382 160.788 52.7114 160.865 51.5503 161.216",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8655 130.567C94.3305 126.807 101.326 131.689 100.621 138.19C107.59 134.483 113.672 143.412 110.618 150.069C115.969 153.072 120.38 159.129 113.646 169.598C106.911 180.068 93.8607 193.096 87.8313 195.419C81.8019 197.743 79.4005 212.651 75.6941 213.695C71.9878 214.739 57.1361 209.283 47.348 200.197C45.4948 198.813 52.7771 185.472 52.7771 185.472C52.7771 185.472 41.7362 170.747 42.0755 163.75C42.702 151.192 49.906 147.485 63.7919 147.328",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.542 138.217C99.3475 142.01 97.4627 145.551 94.9829 148.66",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.539 150.07C110.539 150.07 110.226 152.681 104.954 158.216",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5605 196.932C77.9346 196.082 70.5859 193.579 64.0269 189.596",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.507 38.9535C168.507 49.4774 159.978 58.0085 149.457 58.0085C138.936 58.0085 130.407 49.4774 130.407 38.9535C130.407 28.4295 138.936 19.8984 149.457 19.8984C159.978 19.8984 168.507 28.4295 168.507 38.9535Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.357 38.7196L147.238 43.6019L156.556 34.2812",
    stroke: "#0049FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.394 228.995C232.481 228.995 239.037 222.437 239.037 214.348C239.037 206.259 232.481 199.701 224.394 199.701C216.307 199.701 209.751 206.259 209.751 214.348C209.751 222.437 216.307 228.995 224.394 228.995Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.756 224.713L251.931 241.918",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.007 0L169.685 3.60294C170.018 5.32808 170.86 6.91399 172.102 8.15638C173.344 9.39877 174.93 10.2407 176.654 10.5738L180.256 11.2526L176.654 11.9576C174.93 12.2906 173.344 13.1326 172.102 14.375C170.86 15.6174 170.018 17.2033 169.685 18.9284L169.007 22.5052L168.302 18.9284C167.969 17.2033 167.127 15.6174 165.885 14.375C164.643 13.1326 163.057 12.2906 161.333 11.9576L157.757 11.2526L161.333 10.5738C163.057 10.2407 164.643 9.39877 165.885 8.15638C167.127 6.91399 167.969 5.32808 168.302 3.60294L169.007 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.25 27L309.928 30.5768C310.261 32.302 311.103 33.8879 312.345 35.1302C313.587 36.3726 315.173 37.2146 316.897 37.5477L320.499 38.2526L316.897 38.9314C315.176 39.2711 313.594 40.1152 312.353 41.3565C311.112 42.5977 310.268 44.1801 309.928 45.9023L309.25 49.5052L308.545 45.9023C308.205 44.1801 307.362 42.5977 306.121 41.3565C304.88 40.1152 303.298 39.2711 301.576 38.9314L298 38.2526L301.576 37.5477C303.301 37.2146 304.886 36.3726 306.128 35.1302C307.37 33.8879 308.212 32.302 308.545 30.5768L309.25 27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25 168L308.954 171.577C309.306 173.283 310.156 174.846 311.397 176.068C312.637 177.291 314.213 178.117 315.923 178.443L319.525 179.148L315.923 179.827C314.202 180.167 312.62 181.011 311.379 182.252C310.138 183.493 309.294 185.076 308.954 186.798L308.25 190.401L307.571 186.798C307.231 185.076 306.388 183.493 305.147 182.252C303.906 181.011 302.324 180.167 300.602 179.827L297 179.148L300.602 178.443C302.327 178.11 303.912 177.268 305.154 176.026C306.396 174.783 307.238 173.198 307.571 171.472L308.25 168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 278,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeVitrine);
export default __webpack_public_path__ + "static/media/welcome-vitrine.cef35506e29488dc503683d548c74eb5.svg";
export { ForwardRef as ReactComponent };